// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"0a7c2e60","150":"c02905c9","158":"f0d47b39","186":"4ff3d15c","352":"2563261e","444":"fd108613","695":"71a462c9","736":"9f0dcf12","787":"f309dd56"}[chunkId] + ".chunk.js";
};